const de = {
    application_title: 'Login',
    japanese: 'Japanisch',
    english: 'Englisch',
    french: 'Französisch ',
    german: 'Deutsch',
    italian: 'Italienisch',
    spanish: 'Spanisch',
    language: 'Sprache',
    login_selectscreen: 'Bildschirm auswählen',
    login_all: 'alle',
    login_executive: 'Geschäftsleitung',
    login_manager: 'Manager',
    login_operator: 'Bediener',
    login_forgot_password: 'Haben Sie Ihr Passwort vergessen',
    user_id: 'Benutzer-Name',
    user_password: 'Passwort',
    authorizer: 'Ersteller',
    authorizer_text: 'Hinweis: Bitte geben Sie die E-Mail-Adresse des Bevollmächtigten ein. Der Bevollmächtigte muss ein Konica Minolta-Mitarbeiter sein (ein Benutzer mit einer Konica Minolta-Domäne).',
    sign_in: 'Anmelden',
    sign_in_error: 'Falscher Benutzername oder falsches Passwort',
    create_account: 'Neues Konto erstellen',
    forget_password_title: 'Bitte senden Sie eine Anfrage zum Zurücksetzen des Passworts an die unten stehende E-Mail-Adresse.',
    forget_password_email: 'dashboard-u_support2@gcp.konicaminolta.com',
    forget_password_text: 'Bitte kopieren Sie den unten stehenden Text, fügen Sie ihn in die Betreffzeile ein und senden Sie ihn per E-Mail.\n\
    >[Request] Passwort zurücksetzen\n・Sie können die Hauptnachricht der E-Mail leer lassen.\n\
・Bitte senden Sie die E-Mail von der in dieser Software registrierten E-Mail-Adresse.\n\
・Wir sind möglicherweise nicht in der Lage auf Anfragen von nicht registrierten E-Mail-Adressen zu antworten.\n\
・Wenn Sie innerhalb von 24 Geschäftsstunden keine Antwort erhalten, senden Sie sie bitte erneut.\n\
・Bitte beachten Sie, dass Ihr Konto gelöscht wird, wenn Sie Ihre Anmeldung nicht innerhalb eines Monats nach Erhalt dieser E-Mail bestätigen.\n\
・Bestätigen Sie bitte die Benachrichtigung über das neue Passwort von der folgenden E-Mail Adresse.\n\
"no-reply@verificationemail.com"',
    forget_password_team: 'AccurioPro Dashboard Op-Analysis Operation Team',
    privacy_statement: 'Erklärung zum Datenschutz',
    privacy_statement_contents: 'Bei der Konica Minolta Business Solutions Europe GmbH und ihren Tochter-, Schwester- und Muttergesellschaften, die in der Anlage 1 aufgeführt sind. ("Konica Minolta") nehmen wir das Thema Datenschutz ernst. Diese Datenschutzrichtlinie informiert über die Art und Weise, wie wir personenbezogene Daten erfassen, verwenden, offenlegen und anderweitig verwalten. \n\n\
Wer ist der Datenverantwortliche? \n\
Konica Minolta verwendet Ihre nachstehend genannten personenbezogenen Daten. \n\n\
Welche Informationen sammeln wir über Sie? \n\
Konica Minolta sammelt Ihre E-Mail-Adresse. \n\n\
Wie werden Ihre Informationen verwendet? \n\
Konica Minolta verwendet Ihre oben genannten Daten nur für die unten genannten Zwecke: \n\
Identifizierung und; \n\
Kontaktaufnahme zur Bereitstellung notwendiger Informationen über AccurioPro Dashboard. \n\n\
Was ist unsere Rechtsgrundlage für die Verarbeitung Ihrer personenbezogenen Daten? \n\
Das berechtigte Interesse ist die Rechtsgrundlage für die Verarbeitung. \n\
Berechtigte Interessen sind a) die Identifizierung und b) die Kontaktaufnahme zur Bereitstellung notwendiger Informationen über AccurioPro Dashboard. \n\n\
Wer erhält Ihre Informationen? \n\
Ihre oben genannten persönlichen Daten werden streng vertraulich behandelt und ohne Ihre vorherige Zustimmung nicht an Dritte weitergegeben. \n\n\
Speicherdauer \n\
Konica Minolta verarbeitet personenbezogene Daten während der Dauer, in der Sie AccurioPro Dashboard für Ihren Auftrag nutzen müssen, und speichert nur die erforderlichen personenbezogenen Daten für drei Monate, nachdem Ihr Auftrag geändert wurde oder Sie das Unternehmen verlassen haben ("Wechsel"). Während des Löschzeitraums von der Änderung bis drei Monate nach der Änderung werden alle nicht benötigten personenbezogenen Daten gelöscht, da Konica Minolta nicht benötigte personenbezogene Daten pro Quartal löscht. \n\n\
Datenspeicherung und Datenübermittlung \n\
Die Daten werden in Deutschland gespeichert. Zur Identifizierung und Kontaktaufnahme ist Konica Minolta, Inc. beteiligt.  Japan ist ein Land, das das von der Europäischen Kommission beschlossene angemessene Schutzniveau für personenbezogene Daten gewährleistet. \n\n\
Welche Rechte haben Sie nach der GDPR? \n\
Solange Konica Minolta im Besitz Ihrer personenbezogenen Daten ist oder diese verarbeitet, haben Sie die folgenden Rechte: \n\
Recht auf Zugang - Sie haben das Recht, eine Kopie der Informationen anzufordern, die wir über Sie gespeichert haben. \n\
Recht auf Berichtigung - Sie haben das Recht, unrichtige oder unvollständige Daten, die wir über Sie gespeichert haben, zu korrigieren. \n\
Recht auf Vergessenwerden - unter bestimmten Umständen können Sie verlangen, dass die Daten, die wir über Sie gespeichert haben, aus unseren Unterlagen gelöscht werden. \n\
Recht auf Einschränkung der Verarbeitung - unter bestimmten Bedingungen haben Sie das Recht, die Verarbeitung einzuschränken. \n\
Recht auf Übertragbarkeit - Sie haben das Recht, die Daten, die wir über Sie gespeichert haben, an eine andere Organisation zu übertragen. \n\
Widerspruchsrecht - Sie haben das Recht, gegen bestimmte Arten der Verarbeitung, wie z. B. Direktmarketing, Widerspruch einzulegen. \n\
Recht auf Widerspruch gegen die automatisierte Verarbeitung, einschließlich Profiling - Sie haben auch das Recht, sich den rechtlichen Auswirkungen der automatisierten Verarbeitung oder des Profilings zu widersetzen. \n\
Falls Konica Minolta Ihre Anfrage im Rahmen des Auskunftsrechts ablehnt, werden wir Ihnen eine angemessene Erklärung geben. \n\
Wenn Sie eines Ihrer Rechte geltend machen, senden Sie bitte eine E-Mail an dashboard-u_support1@gcp.konicaminolta.com. \n\n\
Kontaktinformationen des für die Verarbeitung Verantwortlichen \n\
Sie können sich jederzeit an unser Unternehmen wenden, wenn Sie Fragen zum Thema "Datenschutz" haben. Die Kontaktdaten anderer Unternehmen finden Sie in der Anlage.2. \n\n\
Konica Minolta Business Solutions Europe GmbH \n\
Europaallee 17 \n\
30855 Langenhagen \n\
Deutschland Telefon: +49 (0)511 7404-0 \n\
E-Mail: dataprotection(at)konicaminolta.eu \n\n\
Anlage.1 \n\n\n\
Konica Minolta Business Solutions Deutschland GmbH, \n\
Konica Minolta Business Solutions France S.A.S., \n\
Konica Minolta Business Solutions (UK) Limited, \n\
Konica Minolta Business Solutions Romania s.r.l., \n\
Konica Minolta Business Solutions Italia S.p.A., \n\
Konica Minolta Business Solutions Nederland B.V., \n\
Konica Minolta Business Solutions Greece S.A., \n\
Konica Minolta Business Solutions Czech spol. s r.o., \n\
Konica Minolta Hungary Business Solutions Ltd, \n\
Konica Minolta Business Solutions Polska Sp.z.o.o., \n\
Konica Minolta Business Solutions Bulgarien EOOD, \n\
Konica Minolta Business Solutions Slowenien d.o.o., \n\
Konica Minolta Croatia-Business Solutions d.o.o., \n\
Konica Minolta Slovakia spol. s.r.o., \n\
Konica Minolta Baltia UAB, \n\
Konica Minolta Business Solutions Dänemark A/S, \n\
Konica Minolta Business Solutions Spanien S.A., \n\
Konica Minolta Business Solutions Schweden AB, \n\
Konica Minolta Business Solutions Norwegen AS, \n\
Konica Minolta Business Solutions (Belgien) N.V., \n\
Konica Minolta Business Solutions Austria GmbH, \n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda., \n\
Konica Minolta Business Solutions Finland Oy, und \n\
Konica Minolta, Inc. mit Sitz in 2-7-2, Marunouchi, Chiyoda-ku, Tokyo, Japan \n\n\
Anlage.2 \n\n\
Konica Minolta Business Solutions Deutschland GmbH \n\
Europaallee 17, 30855 Langenhagen, Deutschland \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions France S.A.S. \n\
365-367 Route de Saint-Germain, F-78424 Carrieres-sur-Seine, Frankreich \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions (UK) Limited \n\
Miles Gray Road, Basildon, Essex, SS14 3AR, U.K. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Romania s.r.l. \n\
Str. Copilului nr. 18, parter, sector 1, 012178 Bukarest, Rumänien \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Italia S.p.A. \n\
Viale Certosa, 144, 20156 Mailand, Italien \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Nederland B.V. \n\
Hoogoorddreef 9, Postbus 22110, 1100 CC Amsterdam, The Nederland \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Greece S.A. \n\
3, Messologiou Str., GR-14451 Metamorphosis, Athen, Griechenland \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Czech spol. s r.o. \n\
Brünn - Židenice, Žarošická 4395/13, PSČ 628 00, Tschechische Republik \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Hungary Business Solutions Ltd. \n\
Galvani u. 4., 1117 Budapest, Ungarn \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Polska Sp.z.o.o. \n\
Muszkieterów 15, 02-273 Warszawa, Polen \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Bulgarien EOOD \n\
Biznes park Sofia 7, 1715 Sofia, Bulgarien \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Slowenien d.o.o. \n\
Vodovodna cesta 101, 1000 Ljubljana, Slowenien \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Croatia-Business Solutions d.o.o. \n\
Radnicka cesta 1a, HR-10000 Zagreb, Kroatien \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Slovakia spol. s.r.o. \n\
Cernysevskeho 10, 85101 Bratislava, Slowakische Republik \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Baltia UAB \n\
J. Jasinskio str. 16, LT2001 Vilnius, Litauen \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Dänemark A/S \n\
Lautrupvang 2B, 2750 Ballerup, Dänemark \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Spanien S.A. \n\
C/ Albasanz, 12, 28037 Madrid, Spanien \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Schweden AB \n\
Kronborgsgränd 19, S-164 46 Kista, Schweden oder P.O. Box 1125, S-164 22 Kista, Schweden \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Norway AS \n\
Maridalsveien 323, 0872 Oslo, Norwegen \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions (Belgien) N.V. \n\
Excelsiorlaan 10, 1930 Zaventem, Belgien \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Austria GmbH \n\
Amalienstraße 59-61, A-1131 Wien, Österreich \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda. \n\
Rua Professor Henrique de Barros nº 4, 10º B 2685-338 Prior Velho, Portugal \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Finnland Oy \n\
Keilaranta 10 E, 02150 Espoo, Finnland \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta, Inc. \n\
2-7-2 Marunouchi, Chiyoda-ku, Tokio, \n\
Japan \n\
dashboard-u_support1@gcp.konicaminolta.com',
    register: 'Registrieren',
    update: 'Update',
    email: 'E-Mail Adresse',
    fields_compulsory: 'Alle Felder sind Pflichtfelder',
    authorizer_email_error: 'Ungültige E-Mail-Adresse des Bevollmächtigten.',
    email_error: 'Ungültige E-Mail Adresse.',
    username_error: 'Für den Benutzernamen können nur alphanumerische Zeichen eingegeben werden.',
    serial_number_duplicate_error: 'Die Seriennummern sind dupliziert.',
    password_match_error: 'Passwörter stimmen nicht überein',
    not_km_domain: 'Die Domäne der Autorisierungs-E-Mail-Adresse ist keine konicaminolta-Domäne',
    registered: 'Registriert!!!',
    add_account_email_text: 'Sehr geehrter {authorizer},%0D%0A%0D%0A\n{email} haben Ihr Konto für Printer Performance Analysis tool erstellt.%0D%0A%0D%0A\n\n\
Jeder, der kein Mitglied von Konica Minolta ist, kann diese Anwendung mit Genehmigung eines Konica Minolta-Benutzers nutzen.%0D%0A\n\
Loggen Sie sich also bitte unter der folgenden URL ein und geben Sie sie frei.%0D%0A%0D%0A\n\
URL %0D%0A\n\
{URL %0D%0A%0D%0A\n\n\
Mit freundlichen Grüßen,%0D%0A\n\
Konica Minolta Inc.%0D%0A\n\n\
',
    customer_email_text: 'Sehr geehrte {email},%0D%0A%0D%0A\
wir haben Ihr Konto für Printer Performance Analysis tool erstellt.%0D%0ABitte melden Sie sich unter der folgenden URL an.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
Benutzername: {userId}%0D%0A\
password: {password}%0D%0A%0D%0A\
Sie können alle Funktionen dieser Anwendung nutzen, nachdem Sie die PKID in den Lizenzeinstellungen eingegeben haben.%0D%0A\
*Die PKID wird Ihnen separat per E-Mail zugesandt. Bitte beachten Sie dies.%0D%0A%0D%0A\
Mit freundlichen Grüßen,%0D%0AKonica Minolta Inc.',
    request_to_you: 'Anfrage an Sie',
    http_get_error: '{status}: Verarbeitung fehlgeschlagen. Zurück zum Anmeldebildschirm.',
    server_error: 'Interner Serverfehler.',
    http_connection_error: 'Nicht mit dem Internet verbunden.',
    ce_top_title: 'Wählen Sie den Kunden aus, bei dem Sie sich anmelden möchten.',
    add_customers_account: 'Kundenkonto anlegen',
    go_back: 'Zurück',
    customers: 'Ihre Kunden',
    serial_numbers: 'Registrierte Seriennummern',
    open: 'Öffnen',
    add_sn: 'Seriennummer des Druckers hinzufügen',
    add_ce: 'CE hinzufügen, um diesem Kunden zu folgen',
    printers_sn: 'Seriennummer des Druckers',
    edit_customer_title: 'Kundenregistrierung bearbeiten',
    customer_email_address: 'E-Mail Adresse des Kunden',
    license: 'Lizenz',
    printers_registered: 'Registrierte Drucker',
    serial_number: 'Seriennummer',
    latest_data: 'Aktuellste Daten',
    persons_in_charge: 'Zuständige Personen',
    customer_engineer: 'Kunden-Ingenieur',
    sender: 'von',
    authorization: 'Autorisierung',
    approve: 'genehmigen.',
    do_not_approve: 'Nicht genehmigen',
    request_approved: 'Anfrage genehmigt!',
    request_disapproved: 'Anfrage abgelehnt!',
    approved: 'Genehmigt',
    do_not_approved: 'Abgelehnt',
    processed_result: 'Verarbeitetes Ergebnis',
    processed_date: 'Datum der Bearbeitung',
    header_nfr: 'Nicht für den Wiederverkauf bestimmte Lizenz (NFR)',
    header_recommendation: 'Empfehlung',
    header_previous: 'vorherige',
    header_next: 'nächste',
    header_reset: 'zurücksetzen',
    header_change_password: 'Passwort ändern',
    header_settingMenu_tutorial: 'Tutorials',
    header_old_password: 'Aktuelles Passwort',
    header_new_password: 'Neues Passwort',
    header_confirm_password: 'Neues Passwort(Bestätigen)',
    header_cancel: 'Abbrechen',
    header_apply: 'Übernehmen',
    header_ok: 'OK',
    header_close: 'schließen',
    from: 'von',
    to: 'bis',
    change_date_heading: 'Einstellung des Bereichs',
    change_date_explanation: 'Bitte wählen Sie den Zeitrahmen für den CSV-Export',
    header_password_explanation: 'Bitte erstellen Sie ein Passwort mit einer Zeichenfolge von 8 oder mehr Zeichen, einschließlich Groß- und Kleinbuchstaben und Zahlen.',
    header_machine_setting: 'Maschineneinstellung',
    header_machine_setting_title: 'Maschineneinstellung',
    header_machine_setting_notes: 'Maschineneinstellung',
    header_machine_setting_model: 'Modell',
    header_machine_setting_serial_number: 'S/N：',
    header_machine_setting_machine_name: 'Maschinenname',
    header_machine_setting_error_message_max_length: 'Bitte geben Sie maximal 64 Zeichen ein.',
    header_machine_setting_error_message_min_length: 'Bitte geben Sie den Maschinennamen ein.',
    header_machine_setting_error_message_common: 'Bitte prüfen Sie den Inhalt des Gerätenamens.',
    header_machine_setting_complete_message: 'Die Aktualisierung ist abgeschlossen. Laden Sie das Display neu.',
    header_lms_setting: 'Lizenzeinstellung',
    header_lms_explanation: 'Geben Sie den per E-Mail mitgeteilten Produktschlüssel ein, klicken Sie auf die Schaltfläche "Überweisen" und dann auf die Schaltfläche "Aktivieren".',
    header_lms_add: 'Hinzufügen',
    header_lms_delete: 'Löschen',
    header_lms_pkIdTitle: 'Product Key',
    header_lms_refer: 'siehe',
    header_lms_licenseKind: 'Lizenztyp',
    header_lms_licenseDate: 'Lizenz ist abgelaufen',
    header_lms_licenseState: 'Status aktivieren',
    header_lms_activate: 'aktivieren',
    header_lms_deactivate: 'deaktivieren',
    header_lms_state_activate: 'aktivieren',
    header_lms_state_deactivate: 'deaktivieren',
    header_lms_ptl_date: 'Die Testlizenz läuft ab am',
    header_lms_activationDate: 'Aktivierung verfügbar',
    header_lms_never_expired: 'Nie abgelaufen',
    header_users_guide: 'Benutzerhandbuch',
    header_users_guide_link: 'https://www.btapac.konicaminolta.com/users_guide/accuriopress_C14000_series/3_0_0/en/index.html',
    header_version_info: 'Version',
    screen1_productivity_rate: 'Produktivitätsrate',
    screen1_productivity_pred: 'Produktivitätsvorhersage',
    screen1_week_before_last_availability: 'Vorletzte Woche',
    screen1_productivity_diff: 'Tatsächliche Differenz',
    screen1_week_before_last_pred_diff: 'Differenz zwischen der Vorhersage der Vorwoche und der tatsächlichen Entwicklung',
    screen1_productivity_a4_tips: 'Produktivität wird auf A4-Format umgerechnet',
    screen1_productivity_a3_tips: 'Produktivität wird auf A3-Format umgerechnet',
    screen1_results_of_production: 'Ergebnisse der Produktion',
    screen1_est_print_time: 'Voraussichtliche Druckzeit (hh:mm)',
    screen1_act_print_time: 'tatsächliche Druckzeit (hh:mm)',
    screen1_gap: 'Abstand (hh:mm)',
    screen1_sheets: 'Anzahl der Ausdrucke',
    screen1_sheets_per_h: 'Anzahl der Ausdrucke/Stunde',
    screen1_availability: 'Zielerreichungsgrad(%)',
    screen1_job_list_link: 'Auftragsliste',
    screen1_machine_list_link: 'Liste der Maschinen',
    top_manager_title_production_result: 'Gesamt',
    top_manager_title_prints: 'Drucke',
    top_manager_title_errors: 'Fehler',
    top_manager_jobs: 'Druckaufträge',
    top_manager_color_pv: 'Farbseiten',
    top_manager_bw_pv: 'Schwarzweiß-Seiten',
    top_manager_output_paper: 'gedruckte Seiten',
    top_manager_trayfull_count: 'Ausgabefach voll',
    top_manager_paperjams__count: 'Papierstaus',
    top_manager_servicecall_count: 'Service Anruf',
    top_manager_paperempty_count: 'Papierfach leer',
    top_manager_tonerempty_count: 'Toner leer',
    top_operator_title_production_result: 'Ergebnisse des Gerätebetriebs',
    top_operator_title_trouble_result: 'Gesamt',
    top_operator_subtitle_output_paper_result: 'Trend über die Anzahl der ausgegebenen Seiten',
    top_operator_subtitle_output_availability_result: 'Betriebsergebnisse',
    top_operator_paper_count: 'Anzahl der ausgegebenen Bögen',
    top_operator_subtitle_output_paper_count: 'Anzahl der ausgegebenen Bögen',
    top_operator_subtitle_interruption_result: 'Ergebnisse der Unterbrechung (min)',
    top_operator_trayfull: 'Ausgabefach voll',
    top_operator_paperempty: 'Papierfach leer',
    top_operator_tonerempty: 'Toner leer',
    top_operator_paperjams: 'Papierstaus',
    top_operator_servicecall: 'Service Anruf',
    top_operator_explanation_worst1: 'Schlechtester Stoppfaktor ',
    top_operator_explanation_worst2: '2. ',
    top_operator_explanation_worst3: '3.',
    screen3_print_hours: 'Std.',
    listofprintjobs_title: 'Auftragsliste',
    listofprintjobs_number: 'No.',
    listofprintjobs_start_time: 'Startzeit',
    listofprintjobs_job_id: 'Auftragsnummer',
    listofprintjobs_pages_set: 'Seiten/<br>Sets',
    listofprintjobs_output_set: 'Ausgabegeräte',
    listofprintjobs_exit_count: 'Anzahl der ausgegebenen Bögen',
    listofprintjobs_machine_name: 'Drucksystem',
    jobdetail_left_title: 'Auftragsdetails',
    jobdetail_timeline_title: 'Zeitleiste der Ausgabe',
    jobdetail_job_id: 'Auftragsnummer',
    jobdetail_size: 'Papierformat ',
    jobdetail_paper_kind: 'Papiertyp',
    jobdetail_paper_weight: 'Papiergewicht/Stärke',
    jobdetail_color: 'Mono/Farbe',
    jobdetail_side: 'Einseitig / Doppelseitig',
    jobdetail_pages: 'Seiten/Sets',
    jobdetail_unit_pages: 'Seiten',
    jobdetail_units: 'Ausgabegeräte',
    jobdetail_unit_units: 'Anzahl der Sets',
    jobdetail_sheets: 'Anzahl der ausgegebenen Bögen',
    jobdetail_unit_sheets: 'Bögen',
    jobdetail_center_title: 'Drucksystem',
    jobdetail_machine_name: 'Maschinenname',
    jobdetail_tray_full: 'Ausgabefach voll',
    jobdetail_paper_empty: 'Papierfach leer',
    jobdetail_toner_empty: 'Toner leer',
    jobdetail_paper_jam: 'Papierstaus',
    jobdetail_service_call: 'Service Anruf',
    jobdetail_panel_operation: 'Bedieneroberfläche',
    jobdetail_frontdoor_open: 'Systemtür',
    jobdetail_tray_open: 'Papierfach',
    jobdetail_right_title: 'Differenz zwischen voraussichtlicher und tatsächlicher Druckzeit',
    jobdetail_graph_x_title: 'Voraussichtliche Druckzeit (hh:mm)',
    jobdetail_graph_y_title: 'tatsächliche Druckzeit',
    jobdetail_legend_jobs: 'Auftragsausgabe in {machineName}',
    jobdetail_legend_target: 'Dieser Druckauftrag',
    jobdetail_tooltip_jobid: 'Auftragsnummer:',
    jobdetail_tooltip_diff: 'Differenz:',
    jobdetail_tooltip_actual: 'Tatsächliche Druckzeit: ',
    jobdetail_tooltip_assumed: 'Angenommene Druckzeit: ',
    jobdetail_start_time: 'Startzeit',
    jobdetail_end_time: 'Endzeit',
    availabilitydetail_left_title: 'Liste der Maschinen',
    availabilitydetail_center_title: 'Unterschied zwischen Maschinen',
    availabilitydetail_right_title: 'Trend der Druckzeit nach Maschine',
    availabilibydetail_unit_hour: 'Std.',
    availabilibydetail_machine: 'Maschine',
    availabilibydetail_unit_idle: 'Inaktivität',
    availabilibydetail_unit_interruption: 'Druckunterbrechung',
    availabilibydetail_unit_preparation: 'Druckvorbereitung',
    availabilibydetail_unit_printing: 'druckt',
    joblist_title: 'Auftragsliste',
    joblist_number: 'No.',
    joblist_estprinttime: 'Voraussichtliche Druckzeit (hh:mm)',
    joblist_actprinttime: 'reale Druckzeit(hh:mm)',
    joblist_hourlyunits: 'Stündliche Ausgabe an Seiten',
    joblist_printcompletedtime: 'Druckzeit (hh:mm)',
    joblist_printtimediff: 'Gap (hh:mm)',
    joblist_csv_export: 'CSV-Export',
    joblist_est_hourlyunits: 'Voraussichtliche Seiten pro Stunde',
    joblist_est_printcompletedtime: 'Voraussichtliche Druckzeit (hh:mm)',
    joblist_act_hourlyunits: 'Tatsächliche Seiten pro Stunde',
    joblist_act_printcompletedtime: 'tatsächliche Druckzeit',
    proddetail_title: 'Vorhersage Lücke der Druckzeit',
    proddetail_table_title: 'Entwicklung des Produktionsvolumens',
    proddetail_graph_yaxis_left: 'Druckzeit (hh:mm)',
    proddetail_graph_yaxis_right: 'Zielerreichungsgrad(%)',
    proddetail_est_print_time: 'Voraussichtliche Druckzeit',
    proddetail_act_print_time: 'tatsächliche Druckzeit',
    proddetail_gap: 'Abstand (hh:mm)',
    proddetail_duration_daily: 'täglich',
    proddetail_duration_weekly: 'wöchentlich',
    proddetail_duration_monthly: 'monatlich',
    machinedetail_left_title: 'Details zur Maschine',
    machinedetail_center_title: 'Fehler',
    machinedetail_right_title: 'Details zur Maschine verfügbar',
    machinedetail_availability: 'Verfügbarkeit',
    machinedetail_operating_time: 'Betriebsdauer (Stunden)',
    machinedetail_printing_time: 'Druckzeit (Stunden)',
    machinedetail_output_set: 'Ausgabegeräte',
    machinedetail_output_paper: 'Anzahl der ausgegebenen Bögen',
    machinedetail_power_on: 'Einschalten',
    machinedetail_power_off: 'Ausschalten',
    common_min_per_week: 'Minuten/Woche',
    common_2days_ago: 'vorgestern',
    common_yesterday: 'gestern',
    common_today: 'Heute',
    common_tomorrow: 'morgen',
    common_2days_after: 'übermorgen',
    common_2weeks_ago: 'vor 2 Wochen',
    common_last_week: 'Vergangene Woche',
    common_this_week: 'diese Woche',
    common_next_week: 'nächste Woche',
    common_2weeks_after: 'übernächste Woche',
    common_2months_ago: 'vor 2 Monaten',
    common_last_month: 'letzten Monat',
    common_this_month: 'diesen Monat',
    common_next_month: 'nächsten Monat',
    common_2months_after: 'übernächsten Monat',
    common_days_ago: 'vor {dateNum} Tagen',
    common_weeks_ago: 'vor {dateNum} Monaten',
    common_months_ago: 'vor {dateNum} Monaten',
    common_days_after: '{dateNum} Tage nach',
    common_weeks_after: '{dateNum} Wochen nach',
    common_months_after: '{dateNum} Monate nach',
    common_mins: 'Minuten',
    common_hours: 'Std.',
    common_date: 'Datum',
    common_percentage: '%',
    icon_recommendation: 'Empfehlung',
    icon_analysis: 'Analyse',
    icon_operation: 'Betrieb',
    icon_machine: 'Maschine',
    icon_material: 'Material',
    icon_method: 'Methode',
    icon_running_time: 'Laufzeit',
    icon_preparation_time: 'Druckvorbereitung',
    icon_downtime: 'Druckunterbrechung',
    paperEmpty: 'Papier leer',
    tonerEmpty: 'Toner leer',
    trayFull: 'Papierkassette voll',
    Total: 'Gesamt',
    Average: 'AVE.',
    hour_unit: 'Std.',
    date_format: 'DD.MM.YY',
    date_format2: 'DD.MM',
    month_format: 'MM.YY',
    errCode_10000: 'Passwortänderung fehlgeschlagen.',
    errCode_10001: 'Neues Passwort und Neues Passwort (Bestätigen) stimmen nicht überein.',
    errCode_10002: 'Das Passwort muss aus mindestens 8 Zeichen bestehen und Groß- und Kleinbuchstaben sowie Zahlen enthalten.',
    errCode_10003: 'Bitte warten Sie etwa 10 Minuten und ändern Sie dann Ihr Passwort erneut.',
    errCode_10004: 'Das aktuelle Passwort ist falsch.',
    errCode_10005: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    errCode_10006: 'Es ist ein Netzwerkfehler aufgetreten.',
    errCode_10100: 'Es ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.',
    errCode_10101: 'Bitte Produktschlüssel eingeben.',
    errCode_10102: 'Die Produktschlüsselinformationen konnten nicht abgerufen werden.',
    errCode_10103: 'Aktivierung fehlgeschlagen.',
    errCode_10104: 'Die Deaktivierung ist fehlgeschlagen.',
    errCode_10105: 'Die Produktschlüsselinformationen konnten nicht gelöscht werden.',
    errCode_10106: 'Es kann nicht derselbe Produktschlüssel eingestellt werden.',
    errCode_10007: 'Bitte prüfen Sie die Bestätigungs-E-Mail und melden Sie sich über den Link in der E-Mail an.',
    errCode_20000: 'Parameter ist ungültig.',
    errCode_20001: 'Die angegebene Mailadresse existiert bereits.',
    errCode_20002: 'Der angegebene Benutzername existiert bereits. Bitte geben Sie einen anderen Benutzernamen an.',
    errCode_20003: 'Der angegebene Benutzername ist nicht als Kunde registriert.',
    suggestion_overview: 'Übersicht',
    suggestion_pgap_overview_good: 'Abstand der Vorhersage hat sich verringert',
    suggestion_pgap_overview_bad: 'Abstand der Vorhersage hat sich vergrößert',
    suggestion_pgap_overview_even: 'Abstand der Vorhersage hat sich nicht geändert',
    suggestion_ma_overview_good: 'Verfügbarkeitsrate hat sich erhöht',
    suggestion_ma_overview_bad: 'Die Verfügbarkeitsrate ist gesunken',
    suggestion_ma_overview_even: 'Verfügbarkeitsrate hat sich nicht verändert',
    suggestion_attention_machine: 'Maschine erfordert Aufmerksamkeit: ',
    suggestion_tips: 'Tipps',
    suggestion_pv_up: 'Druckvolumen gestiegen',
    suggestion_pv_down: 'Druckvolumen gesunken',
    suggestion_pv_even: 'Druckvolumen unverändert',
    suggestion_downtime_long: 'Ausfallzeit gestiegen',
    suggestion_smalljob_many: 'Kleinserienaufträge gestiegen',
    suggestion_efficiency_up: 'Die Produktionseffizienz ist gestiegen',
    ce_login_tutorial: 'Für die Bereitstellung siehe Tutorial',
    ce_dialog_header_confirm: 'Bestätigung',
    ce_confirmation_message: 'Möchten Sie die Kundendaten wirklich aktualisieren?',
    ce_email_confirmation: 'Es wird eine E-Mail zur Initialisierung des Kundenpassworts erstellt. Sind Sie sicher?',
    username_email: 'Benutzername (E-Mail Adresse)',
    ce_dialog_header_info: 'Information',
    ce_account_complete_kmce: 'Die Registrierung des Kontos ist abgeschlossen. Gehen Sie zum Anmeldebildschirm.',
    ce_account_complete_dealer: 'Die Anfrage zur Kontoregistrierung wurde abgeschlossen. Bitte warten Sie bis zur Genehmigung.',
    ce_user_account_complete_kmce: 'Die Registrierung des Kontos ist abgeschlossen.',
    ce_user_account_complete_dealer: 'Die Anfrage zur Kontoregistrierung wurde abgeschlossen. Bitte warten Sie bis zur Genehmigung.',
    ce_error_400: 'Es ist ein Fehler aufgetreten. Bitte überprüfen Sie den Inhalt.',
    ce_error_409: 'Informationen erneut abrufen, weil sie von einem anderen Benutzer aktualisiert worden sind',
    ce_top_operator_user_name: 'Der oberste Bedienerbildschirm von {userName}',
    add_new_customer: 'Neuen Kunden hinzufügen',
    add_existed_customer: 'Bestehenden Kunden hinzufügen',
    ce_edit_licenseExpiresOn: 'Läuft ab am',
    send_mail: 'Mail erfolgreich gesendet.',
    password_change_complete: 'Passwortänderung abgeschlossen.',
    reset_password: 'Passwort zurücksetzen',
    change_button: 'ändern',
    send_button: 'senden',
    common_error_500: 'Verarbeitung fehlgeschlagen.',
    error_send_mail: 'Die Mail konnte nicht gesendet werden.',
    error_confirm_password_incorrect: 'Das Passwort und das Bestätigungspasswort sind unterschiedlich.',
    error_usename_not_exist: 'Der angegebene Nutzername existiert nicht.',
    error_id_not_exist: 'Die angegebene ID existiert nicht.',
    error_id_mailaddress_not_exist: 'Die angegebene ID oder E-Mail-Adresse existiert nicht.',
    ce_forget_password_dialog_message: 'Bitte ändern Sie Ihr Passwort über die im Text der E-Mail angegebene URL.',
    user_forget_password_dialog_message: 'Bitte bestätigen Sie erneut, wenn Sie es ändern möchten, da dies alle Mitglieder betrifft, die dieses Konto verwenden. Die E-Mail mit dem neuen Passwort wird Ihnen zugesandt. Bitte melden Sie sich mit dem in der E-Mail angegebenen Passwort an. Wenn Sie Ihre E-Mail-Adresse nicht kennen, wenden Sie sich bitte an den zuständigen CE.',
    Mon: 'Mo',
    Tue: 'Di',
    Wed: 'Mi',
    Thu: 'Do',
    Fri: 'Fr',
    Sat: 'Sa',
    Sun: 'So',
    header_pending_verification: 'Prüfe Verifizierung ',
    pending_verification_dialog_message: 'Das Konto ist gesperrt, weil es zu lange nicht benutzt wurde. Müssen Sie eine Bestätigungs-E-Mail senden?',
    trial_license_expired_message: 'La licence d\'essai a expiré. Veuillez saisir la clé du produit',
    errCode_20004: 'ungültige URL',
    error_code: 'Störungscode',
    jam_location: 'Stau Lokation',
    device_time: 'Zeitpunkt',
    machine_name: 'Maschine',
    paperJamsList_title: 'Liste der Papierstaus',
    error_support: 'Solution',
    error_describe: 'Fehlerdetails',
    serviceCallList_title: 'Liste der Serviceaufrufe',
    tray: 'Einzugsfach',
    paperEmptyList_title: 'Liste der Leerstandsmeldungen auf Papier',
    output_tray_name: 'Ausgabefach',
    trayFullList_title: 'Liste Fach voll Meldungen',
    tonerEmptyList_title: 'Liste Toner leer Meldungen',
    toner_color: 'Farbe des Toners',
    errorCount_tip: 'Die Liste wurde aufgrund von Analyse- oder Nummernbeschränkungen ausgesetzt',
    solve_time: 'Auflösungszeit',
    change_language: 'Sprache ändern',
    machine_tab: 'Basis',
    custom_group_tab: 'benutzerdefiniert',
    group_name: 'Gruppenname',
    group_checkbox_tip: 'Die markierte Gruppe wird auf der Benutzeroberfläche auswählbar sein.',
    group_edit_tip: 'Sie können einen benutzerdefinierten Satz von Maschinenanzeigen hinzufügen.',
    custom_group: 'Benutzerdefinierter Gruppenname',
    group_comment: 'Kommentar',
    machine_checkbox_tip: 'Die markierte Maschine wird angezeigt, wenn die Gruppe ausgewählt wird.',
    group_name_exits: 'Der angegebene Gruppenname existiert bereits.',
    header_group_name_max_length: 'Bitte geben Sie 64 Zeichen oder weniger ein.',
    header_group_name_min_length: 'Bitte geben Sie den Gruppennamen ein.',
    header_group_comment_max_length: 'Bitte geben Sie 128 Zeichen oder weniger ein.',
    header_device_group_switch: 'Gerätegruppe:',
    header_group_all: 'Alle(Bögen)',
    header_group_color: 'Farbe',
    header_group_monochrome: 'Schwarzweiß',
    header_group_detail_length: 'Es muss mindestens ein Gerät in der benutzerdefinierten Gruppe ausgewählt werden.',
    header_group_select_tip: 'Es gibt keine Maschine in der ausgewählten Gruppe. Registrieren Sie das Gerät in der Gruppe.',
    group_name_specialchar_tip: 'Sonderzeichen @ kann nicht eingegeben werden',
    change_date_heading_week: 'Wochenauswahl',
    machine_time_line: 'Zeitleiste',
    header_group_ppall: 'AccurioPress/Print',
    header_group_km1: 'AccurioJet',
    top_manager_otherTransporterror_count: 'Sonstiger Transportfehler',
    otherTransportErrorList_title: 'Liste der sonstigen Transportfehler',
    jobdetail_otherTransporterror: 'Sonstiger Transportfehler',
    top_operator_otherTransporterror: 'Sonstiger Transportfehler',
    errCode_10008: 'Der Schlüssel ist falsch oder abgelaufen.',
    feeder: 'Zuführung',
    license_expired_message: 'Ihre Lizenz ist abgelaufen',
    logout_dialog_msg: 'Alle Funktionen können nicht genutzt werden, solange die Lizenz nicht gültig ist. ',
    header_logout_yes: 'Abmeldung',
    header_logout_no: 'Abbrechen',
    paper_weight: 'Papiergewicht',
    paper_thickness: 'Stärke',
    errCode_10009: 'Die SN ist nicht registriert.',
    errCode_10010: 'Anmeldung erforderlich',
    errCode_10011: 'Kein Gerät registriert',
    ce_reset_password_dialog_title: 'Benachrichtigung über Kundenkontoinformationen',
    ce_reset_password_dialog_ultimate: 'Op-Analysis zurücksetzen',
    ce_reset_password_dialog_job_manager: 'JobManager zurücksetzen',
    ce_reset_password_dialog_all: 'Beide zurücksetzen',
    customer_email_text_job_manager: 'Sehr geehrte {email},%0D%0A%0D%0A\
wir haben Ihr Konto für AccurioPro Dashboard JobManager erstellt.%0D%0Bitte melden Sie sich unter der folgenden URL an.%0D%0A\
URL: https://dashboard-jm.konicaminolta.com%0D%0A\
Benutzername: {userId}%0D%0A\
Bediener-ID: administrator%0D%0A\
password: {password}%0D%0A%0D%0A\
Sie können alle Funktionen dieser Anwendung nach der Eingabe des Produktschlüssels in der Lizenzeinstellungsfunktion nutzen.%0D%0A\
*Der Produktschlüssel wird Ihnen separat per E-Mail zugesandt. Bitte beachten Sie dies.%0D%0A%0D%0A\
Mit freundlichen Grüßen,%0D%0AKonica Minolta Inc.',
    customer_email_text_all: 'Sehr geehrte {email},%0D%0A%0D%0A\
wir haben Ihr Konto für Printer Performance Analysis tool und AccurioPro Dashboard JobManager erstellt.%0D%0Bitte melden Sie sich unter der folgenden URL an.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
Benutzername: {ultimateUserId}%0D%0A\
Bediener-ID: administrator%0D%0A\
Op-Analysis Kennwort: {ultimatePassword}%0D%0A\
JobManager-Kennwort: {jobManagerPassword}%0D%0A%0D%0A\
Sie können alle Funktionen dieser Anwendung nach Eingabe des Produktschlüssels in den Lizenzeinstellungen nutzen.%0D%0A\
*Der Produktschlüssel wird Ihnen separat per E-Mail zugesandt. Bitte beachten Sie dies.%0D%0A%0D%0A\
Mit freundlichen Grüßen,%0D%0AKonica Minolta Inc.',
    TZ_0000: 'Europe/West/GB, PT (+0)',
    TZ_0100: 'Europe/Central/FR, DE (+1)',
    TZ_0200: 'Europe/East/UA, GR (+2)',
    TZ_0300: 'Europe/East/TR, Moscow (+3)',
    TZ_0630: 'Asia/India (+5.5)',
    TZ_0700: 'Asia/Viet Nam (+7)',
    TZ_0800: 'Asia/China (+8)',
    TZ_0900: 'Asia/Japan, Korea (+9)',
    TZ_1400: 'Pacific/Hawaii (-10)',
    TZ_1500: 'America/Alaska (-9)',
    TZ_1600: 'America/West/Los Angeles (-8)',
    TZ_1700: 'America/Mountain/Denver (-7)',
    TZ_1800: 'America/Central/Chicago (-6)',
    TZ_1900: 'America/East/New York (-5)',
    TZ_2100: 'South America/Sao Paulo (-3)',
    time_zone_title: 'Zeitzone',
    local_time: 'Ortszeit',
    header_user_id: 'Benutzer-Name',
    ce_customers_list_title: 'Kundenliste',
    ultimate_license_expires_on: 'Op-Analysis (Verfallsdatum)',
    jm_license_expires_on: 'Job Manager (Ablaufdatum)',
    ce_customers_list_search: 'Suche',
    ce_edit_registered: 'registriert',
    ce_edit_serialNumber: 'Seriennummer (Drucksystem)',
    ce_edit_lastUpdatedDate: 'Datum der letzten Aktualisierung',
    ce_edit_responsibleCE: 'Verantwortlicher Servicetechniker',
    ce_edit_customerInfo: 'Kundeninformation',
    ce_edit_utimate: 'Op-Analysis',
    ce_edit_addSerialNumber: 'Seriennummer hinzufügen',
    ce_edit_jobManager: 'Job Manager',
    ce_edit_commonInfo: 'Allgemeine Informationen',
    ce_header_editCustomers: 'Kunden bearbeiten',
    ce_add_addCustomers_title: 'Sie können ein neues Kundenkonto hinzufügen',
    ce_serial_number_list: 'Seriennummer',
    ce_essential_link_file: 'Essential Linked file',
    ce_location_on_off: 'Beta features on / off',
    date: 'Date',
    before_suggistion: 'Original suggestion text',
    after_suggestion: 'Suggestion to be updated',
    batch_edit: 'Bulk update',
    data_error: 'The data has been updated. Please refresh and save again.',
    edit_suggestion: 'Edit Suggestion',
    suggestion: 'Suggestion',
    user_suggestion_list: 'Suggestion list',
    delete_suggestion: 'Delete',
    top_operator_adjustment: 'Maintenance',
    color: 'Farbe',
    monochrome: 'Mono',
    duplex: 'Doppelseitig',
    simplex: 'Einseitig',
    undefined_paper: 'Ohne',
    normal_paper: 'Normalpapier',
    colored_paper: 'Farbiges Papier',
    high_quality_paper: 'Qualitätspapier',
    color_paper: 'Farbig bedrucktes Papier',
    coated_gloss_laser_paper: 'Laserpapier beschichtet-G',
    coated_mat_laser_paper: 'Laserpapier beschichtet-M',
    coated_gloss_offset_paper: 'Offsetpapier beschichtet-G',
    coated_mat_offset_paper: 'Offsetpapier beschichtet-M',
    embossing_paper: 'Strukturiertes Papier',
    envelope: 'Umschlag',
    rough_paper: 'Raues Papier',
    book_paper: 'Buchpapier',
    coated_paper: 'Beschichtetes Papier',
    preprinted_paper: 'Vorbedrucktes Papier',
    blank_insert_paper: 'Leeres Trennblatt',
    generate_suggestion: 'Automated suggestion',
    error_Duration: 'Error Duration',
    jobdetail_processing_time: 'Processing Time',
    job_start_time: 'Startzeit',
    job_end_time: 'Endzeit',
    add_customer_user_id: 'User name (for Customer login)',
    add_customer_email_address: 'Customer contact e-mail address',
    change_date_heading_day: 'Date selector',
    no_log: 'Dashboard Op-Analysis logs are not sent to CSRA/CSRC',
    unused_log: 'Dashboard Op-Analysis logs are not included in CSRA/CSRC logs',
    datetime_format: 'DD.MM.YY HH:mm:ss',
    header_jobs: 'Jobs',
    no_rows_label: 'Keine daten',
    date_format3: 'DD.MM HH:mm',
    aqa_main_reason_fd_k: 'Vertical streak K',
    aqa_main_reason_fd_c: 'Vertical streak C',
    aqa_main_reason_fd_m: 'Vertical streak M',
    aqa_main_reason_fd_y: 'Vertical streak Y',
    aqa_main_reason_cd_k: 'Horizontal streak K',
    aqa_main_reason_cd_c: 'Horizontal streak C',
    aqa_main_reason_cd_m: 'Horizontal streak M',
    aqa_main_reason_cd_y: 'Horizontal streak Y',
    aqa_main_reason_dba_k: 'Uneven density K',
    aqa_main_reason_dba_c: 'Uneven density C',
    aqa_main_reason_dba_m: 'Uneven density M',
    aqa_main_reason_dba_y: 'Uneven density Y',
    aqa_main_reason_spot_k: 'Spot K',
    aqa_main_reason_spot_c: 'Spot C',
    aqa_main_reason_spot_m: 'Spot M',
    aqa_main_reason_spot_y: 'Spot Y',
    aqa_main_reason_backside_stain: 'Stain',
    machine_detail_timeline: 'Machine Detail Timeline',
    machine_detail_score_transition: 'Image total score transition',
    machine_detail_score_details: 'Diagnostic score details',
    machine_detail_diagnostic_history: 'DIAGNOSTIC HISTORY (Simple/Detailed)',
    machine_detail_dba_history: 'Maximum density transition',
    aqa_score_trend: 'Score',
    aqa_score_average_28days_trend: 'Trend (28 days average)',
    day_time: 'Date time',
    machine_id: 'MachineID',
    overall_score: 'Overall Score',
    main_factors: 'Main factors',
    machine_detail_score: 'Comprehensive image score',
    machine_detail_score_last_date: 'Latest date',
    machine_detail_score_last_num: 'Latest score',
    machine_detail_score_average_num: 'Historical average score',
    machine_detail_score_major_factor: 'Main factor',
    machine_detail_score_last: 'Latest score:',
    machine_detail_score_average_28days: '28 days average score:',
    aqa_diagnostic_score_legend_error: 'Error',
    aqa_diagnostic_score_legend_warning: 'Warning',
    aqa_diagnostic_score_legend_ok: 'OK',
    aqa_diagnostic_score_subtitle: 'Diagnostic Item',
    aqa_color: 'Color',
    aqa_fd_streak_rank: 'Vertical streak',
    aqa_cd_streak_rank: 'Horizontal streak',
    aqa_cd_banding_rank	: 'CD Banding',
    aqa_blurry_white_spot: 'White spot noise',
    aqa_blurry_color_spot: 'Color spot noise',
    aqa_white_spot: 'White speckle',
    aqa_black_spot: 'Black speckle',
    aqa_inky_backside: 'Stain',
    aqa_uneven_density: 'Uneven density',
    aqa_dba_adapt: '(Adjusted)',
    aqa_quality_information: 'Display AQA Quality Information',
    ce_sn_validation: 'Serial number should be 13 characters for KM printer',
    aqa_history_table_title: 'Image diagnosis (Simple/Detailed)',
    date_format4: 'DD.MM.YY HH:mm',
    header_group_AccurioLabel: 'AccurioLabel',
    header_group_registered_mixed_error: 'Web-fed machine can\'t be registered mixed with sheet-fed machine',
    label_machine_printed_length: 'Print length',
    label_machine_printed_length_with_unit: 'Print length(m)',
    label_machine_act_printed_length_with_unit: 'Act. Print length(m)',
    label_machine_printed_length_unit: 'm',
    label_machine_printed_length_time_unit: 'm/hour',
    label_machine_printed_length_with_unit2: 'Length/Set',
    label_machine_top_operator_subtitle_printed_length_result: 'Trend of print length',
    label_machine_top_operator_act_printed_length: 'Act. Print length',
    label_machine_screen_sheets_per_h: '#of prints(m/hour)',
    label_machine_joblist_est_hourlyunits: 'Pred. Print length(m/hour)',
    label_machine_joblist_act_hourlyunits: 'Act. Print length(m/hour)',
    header_machine_setting_remove_group_confirmation: 'Are you sure you want to remove this group "{group}"?',
    machinedetail_passed_day: '(Last 7 Days)',
    machinedetail_passed_week: '(Last 4 Weeks)',
    machinedetail_passed_month: '(Last 4 Months)',
    label_machine_waste_paper_length: 'Waste paper length',
    change_disabled_date_heading: 'Range',
    change_disabled_date_explanation: 'The duration of the CSV export',
    ce_edit_transportLog: 'Transport Log',
    ce_edit_transportLog_dialog_title: 'Transport Log Setting',
    ce_edit_transportLog_dialog_no: 'No.',
    ce_edit_transportLog_dialog_dev_env: 'Transport dev',
    ce_edit_transportLog_dialog_dev_stag: 'Transport sam',
    current_page: 'Current page:',
    total_pages: 'Total Pages:',
    ds_version_title: 'Version',
    ds_dashboard_version: 'KONICA MINOLTA AccurioPro Dashboard CE Version',
    ds_version_ds_num: '1.4.3',
    ds_version_oss: 'Disclosure of OSS information',
    ds_version_copyright: 'Copyright(C)2022',
    ds_version_companyName: 'KONICA MINOLTA.INC.',
    ds_import_cancle_btn: 'Close',
    header_settingMenu_version: 'Version',
    ce_application_sub_title: 'For Customer Engineers',
    ce_authorizer: 'Approver Email Address',
    ce_addCustomers_JMAndAQA_title: 'Both JobManager and Op-Analysis',
    ce_request_subTitle: 'Customer Info',
    ce_request_header_date: 'request date',
    ce_request_header_contents: 'contents',
    ce_header_link_request: 'request confirm',
    ce_edit_email_button: 'edit',
};
export default de;
